/*
  Paged product thumbnail strip (snippets/product-thumbnails.liquid, paged: true).

  This script is the only thing that scrolls the strip. The paged markup has no
  .scroll-button or .scroll-sentinal, so theme.js scrollContainer() finds
  nothing to bind; before, both scripts handled every arrow click with
  different offsets and the strip stopped mid-thumbnail.

  - Arrows move one full page of whole thumbnails; CSS scroll-snap keeps
    trackpad and touch flings aligned to a thumbnail edge as well.
  - Mouse drag scrolls the strip; a drag never counts as a thumbnail click.
  - A thin progress bar shows where the visible window sits in the set.
  - 'thumbs:reveal' on a thumbnail scrolls the strip (never the page) so that
    thumbnail is fully visible; the gallery fires it when the active image changes.
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function behavior() {
    return reduceMotion.matches ? 'auto' : 'smooth';
  }

  function init(root) {
    if (root.__thumbsPaged) return;
    root.__thumbsPaged = true;

    var viewport = root.querySelector('[data-thumbs-viewport]');
    var prev = root.querySelector('[data-thumbs-prev]');
    var next = root.querySelector('[data-thumbs-next]');
    var bar = root.querySelector('[data-thumbs-progress]');
    if (!viewport) return;

    function items() {
      return Array.prototype.slice.call(viewport.querySelectorAll('.product-thumbnails__item'));
    }

    function maxScroll() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }

    function update() {
      var max = maxScroll();
      var left = viewport.scrollLeft;
      var atStart = left <= 2;
      var atEnd = left >= max - 2;
      root.setAttribute('data-at-start', atStart ? 'true' : 'false');
      root.setAttribute('data-at-end', atEnd ? 'true' : 'false');
      root.toggleAttribute('data-overflowing', max > 2);
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (bar && viewport.scrollWidth > 0) {
        var size = viewport.clientWidth / viewport.scrollWidth;
        var pos = max > 0 ? left / max : 0;
        bar.style.width = size * 100 + '%';
        bar.style.transform = 'translateX(' + pos * (1 / size - 1) * 100 + '%)';
      }
    }

    // Left edge of the first thumbnail that is not fully visible in the
    // chosen direction, so a page step always lands on a whole thumbnail.
    function pageTarget(dir) {
      var list = items();
      if (!list.length) return viewport.scrollLeft;
      var vpLeft = viewport.scrollLeft;
      var vpRight = vpLeft + viewport.clientWidth;
      var base = list[0].offsetLeft;
      var i;
      if (dir > 0) {
        for (i = 0; i < list.length; i++) {
          var right = list[i].offsetLeft - base + list[i].offsetWidth;
          if (right > vpRight + 1) return list[i].offsetLeft - base;
        }
        return maxScroll();
      }
      // Backwards: the first thumbnail that still fits when the page ends
      // where the current one starts.
      var desired = vpLeft - viewport.clientWidth;
      for (i = 0; i < list.length; i++) {
        if (list[i].offsetLeft - base >= desired - 1) return list[i].offsetLeft - base;
      }
      return 0;
    }

    function go(dir) {
      var target = Math.min(maxScroll(), Math.max(0, pageTarget(dir)));
      viewport.scrollTo({ left: target, behavior: behavior() });
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });

    root.addEventListener('thumbs:reveal', function (e) {
      var item = e.target.closest('.product-thumbnails__item');
      if (!item || dragged) return;
      var base = items()[0].offsetLeft;
      var left = item.offsetLeft - base;
      var right = left + item.offsetWidth;
      var vpLeft = viewport.scrollLeft;
      var vpRight = vpLeft + viewport.clientWidth;
      if (left < vpLeft) viewport.scrollTo({ left: left, behavior: behavior() });
      else if (right > vpRight) viewport.scrollTo({ left: right - viewport.clientWidth, behavior: behavior() });
    });

    // Mouse drag. Touch and pen use native scrolling, which already snaps.
    var dragging = false;
    var dragged = false;
    var startX = 0;
    var startLeft = 0;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || maxScroll() <= 0) return;
      dragging = true;
      dragged = false;
      startX = e.clientX;
      startLeft = viewport.scrollLeft;
    });

    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) < 5) return;
      if (!dragged) {
        dragged = true;
        root.classList.add('is-dragging');
      }
      viewport.scrollLeft = startLeft - dx;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      if (!dragged) return;
      root.classList.remove('is-dragging');
      // Snap is off while dragging; settle on the nearest thumbnail edge.
      var list = items();
      var base = list.length ? list[0].offsetLeft : 0;
      var best = viewport.scrollLeft;
      var bestDist = Infinity;
      list.forEach(function (it) {
        var d = Math.abs(it.offsetLeft - base - viewport.scrollLeft);
        if (d < bestDist) { bestDist = d; best = it.offsetLeft - base; }
      });
      viewport.scrollTo({ left: Math.min(maxScroll(), best), behavior: behavior() });
      // The click that ends a drag must not switch the image.
      setTimeout(function () { dragged = false; }, 0);
    }

    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    viewport.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var raf = 0;
    viewport.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(update).observe(viewport);
    window.addEventListener('load', update, { once: true });
    update();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-thumbs-paged]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Variant changes re-render the left column (theme.js _refreshOverviewWithVariant)
  // and the theme editor reloads sections; pick up the new strip either way.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  var pending = 0;
  new MutationObserver(function () {
    if (pending) return;
    pending = requestAnimationFrame(function () { pending = 0; initAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
